export const data: Record<
  string,
  {
    editAliasTitle: string
    editAliasSubtitle: string
    currentAliasLabel: string
    newAliasLabel: string
    saveButton: string
    aliasRequiredError: string
    rulesTitle: string
    rule1: string
    rule2: string
    rule3: string
    authenticationError: string
  }
> = {
  'en-US': {
    editAliasTitle: 'Edit Alias',
    editAliasSubtitle: 'Enter the new Alias ID that will be used to receive transfers.',
    currentAliasLabel: 'Current Alias',
    newAliasLabel: 'New alias',
    saveButton: 'Save',
    aliasRequiredError: 'Alias is required',
    rulesTitle: 'Rules to create your Alias:',
    rule1: 'Use 6 to 20 characters.',
    rule2: 'You can include letters, numbers, dots, and hyphens.',
    rule3: "Don't use spaces, accents, or symbols.",
    authenticationError: 'Authentication failed',
  },
  'es-ES': {
    editAliasTitle: 'Editar alias',
    editAliasSubtitle:
      'Ingresá el nuevo identificador Alias que vas a usar para recibir transferencias.',
    currentAliasLabel: 'Alias actual',
    newAliasLabel: 'Nuevo alias',
    saveButton: 'Guardar',
    aliasRequiredError: 'El alias es obligatorio',
    rulesTitle: 'Reglas para crear tu Alias:',
    rule1: 'Usá entre 6 y 20 caracteres.',
    rule2: 'Podés incluir letras, números, punto y guion.',
    rule3: 'No uses espacios, acentos ni símbolos.',
    authenticationError: 'Autenticación fallida',
  },
}
